export default{install:function install(Vue,options){var nl2br=function nl2br(x){return x.replace(/[\n\t\r]/g,'<br/>')};Vue.directive('nlbr',{bind:function bind(el,binding,vnode,oldVnode){if(binding.value)el.innerHTML=nl2br(binding.value)},update:function update(el,binding,vnode,oldVnode){if(binding.value)el.innerHTML=nl2br(binding.value)}});Vue.nl2br=Vue.prototype.$nl2br=function(text){return nl2br(text)}}};


//////////////////
// WEBPACK FOOTER
// ./app/js/nl2br.js
// module id = 201
// module chunks = 0